'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commandConstants = require('./commandConstants');

var _draftjsConstants = require('../../draftjsConstants');

// Constants
exports.default = function (command, _ref) {
    var getProps = _ref.getProps;

    if (command !== _commandConstants.EMPTY_DELETE) return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;

    var _getProps = getProps(),
        saveCurrentContent = _getProps.saveCurrentContent,
        onEmptyBackspace = _getProps.onEmptyBackspace;

    saveCurrentContent && saveCurrentContent();
    onEmptyBackspace && onEmptyBackspace();
    return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/deleteOnEmpty/handleKeyCommand.js
// module id = 1728
// module chunks = 0